import React from "react";
import searchIcon from "../../assets/images/search_rgb_red.svg";
import downloadIcon from "../../assets/images/download_rgb_red.svg";
import {
  Button,
  Col,
  Container,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import "../../assets/styles/postcodes.scss";
import { useFileExport } from "../../hooks/useFileExport";

const PostcodesButtons = ({ onSearch, filters = {} }) => {
  const { exportFile, isExporting } = useFileExport(
    "/Postcode/Csv",
    "postcodes.csv"
  );

  const renderDownloadTooltip = (props) => (
    <Tooltip id="edit-tooltip" {...props}>
      Eksportuj dane spełniające kryteria
    </Tooltip>
  );
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        onSearch?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onSearch]);

  const handleDownloadCsv = async () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    const qs = queryParams.toString();
    if (!qs) {
      alert(
        "Proszę wprowadzić co najmniej jeden filtr przed eksportem do pliku."
      );
      return;
    }

    const filtersToExport = Object.fromEntries(
      [...queryParams.entries()].map(([k, v]) => [k, v])
    );

    try {
      await exportFile(filtersToExport);
     
    } catch (e) {
      alert("Wystąpił błąd podczas eksportu CSV.");
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderDownloadTooltip}
          >
            <Button
              className="postcodes-button"
              onClick={handleDownloadCsv}
              disabled={isExporting}
            >
              <img
                src={downloadIcon}
                alt="Download"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <Button className="postcodes-button" onClick={onSearch}>
            <img
              src={searchIcon}
              alt="Search"
              style={{ width: "75%", height: "75%" }}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
export default PostcodesButtons;
